export default [{
    icon: ['left', 'fal', 'percent'],
    text: 'Low Interest',
    color: 'green',
    value: 'low_interest'
},
{
    icon: ['left', 'fal', 'money-bill-wave'],
    text: 'Cash Back',
    color: 'purple',
    value: 'cash_back'
},
{
    icon: ['left', 'fal', 'gift'],
    text: 'Reward',
    color: 'orange',
    value: 'rewards'
},
{
    icon: ['left', 'fal', 'user-graduate'],
    text: 'Student',
    color: 'blueish',
    value: 'student'
},
{
    icon: ['left', 'fal', 'plane-departure'],
    text: 'Travel',
    color: 'lime',
    value: 'travel'
},
{
    icon: ['left', 'fal', 'chart-line'],
    text: 'Credit Building',
    color: 'yellow',
    value: 'credit_building'
},
{
    icon: ['left', 'fal', 'briefcase'],
    text: 'Business',
    color: 'blueish',
    value: 'business'
},
{
    icon: ['left', 'fal', 'exchange'],
    text: 'Balance Transfer',
    color: 'green',
    value: 'balance_transfer'
},
{
    icon: ['left', 'fal', 'dollar-sign'],
    text: 'Prepaid',
    color: 'purple',
    value: 'prepaid'
}];